import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';
import {CSSTransitionGroup} from 'react-transition-group';
import {withConfig, withI18n} from 'spa/Components/Context';

import Header from '../Components/Header';
import LandingFooter from 'spa/Pages/Landing/Verticals/Components/LandingFooter';

import ChatButton from '../Components/ChatButton';
import SalesforceChatButton from '../Components/SalesforceChatButton';

@inject(({
  store,
}) => (
  {
    store,
  }
))
@withConfig
@withI18n
class Main extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object.isRequired,
    store: PropTypes.shape({
      initialLoadComplete: PropTypes.bool,
    }),
  };

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;

    this.salesforceChatEnabled = config.getValue('locale.salesforce-chat-enabled', i18n.umRegion);

    if (typeof window !== 'undefined') {
      window.addEventListener ?
        window.addEventListener('load', () => {
          this.props.store.initialLoadComplete = true;
        }, false) :
        window.attachEvent && window.attachEvent('onload', () => {
          this.props.store.initialLoadComplete = true;
        });
    }
  }

  render() {
    const {children, location} = this.props;
    const {salesforceChatEnabled} = this;

    return (
      <div className="v-container full-height">
        <Header className="v-content" useHeading />
        <div className="v-content v-content--expand">
          <CSSTransitionGroup
            component="div"
            className="cross-fade-container"
            transitionName="cross-fade"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {children && React.cloneElement(React.Children.only(children), {
              key: location.pathname,
            })}
          </CSSTransitionGroup>
        </div>
        {salesforceChatEnabled ? (
          <SalesforceChatButton />
        ) : (
          <ChatButton />
        )}
        <LandingFooter className="v-content" />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./spa/Pages/MainWhite.jsx